/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Shrnutí vaší objednávky`
};

const da_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Ordreoversigt`
};

const de_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellübersicht`
};

const en_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Summary of your order`
};

const es_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Resumen de tu pedido`
};

const fr_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Résumé de votre commande`
};

const hu_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés összefoglalása`
};

const it_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Riepilogo ordine`
};

const nl_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Overzicht van je bestelling`
};

const pl_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Podsumowanie zamówienia`
};

const pt_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Resumo do seu pedido`
};

const sv_order_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Din ordersammanfattning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_summary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_summary(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_summary", locale)
	if (locale === "cs") return cs_order_summary(inputs)
	if (locale === "da") return da_order_summary(inputs)
	if (locale === "de") return de_order_summary(inputs)
	if (locale === "en") return en_order_summary(inputs)
	if (locale === "es") return es_order_summary(inputs)
	if (locale === "fr") return fr_order_summary(inputs)
	if (locale === "hu") return hu_order_summary(inputs)
	if (locale === "it") return it_order_summary(inputs)
	if (locale === "nl") return nl_order_summary(inputs)
	if (locale === "pl") return pl_order_summary(inputs)
	if (locale === "pt") return pt_order_summary(inputs)
	return sv_order_summary(inputs)
};